import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { PATH_EMPLOYEE_PAYROLL_TYPES } from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'

const employeePayrollTypes = {
  namespaced: true,
  state: buildInitialState({
    employeePayrollTypeList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setEmployeePayrollTypes: (state, employeePayrollTypes) => {
      state.employeePayrollTypeList = employeePayrollTypes
    }
  },
  actions: {
    getEmployeePayrollTypes: ({ commit }) => {
      commit('updateStatus', { status: IN_PROGRESS })

      return api.doGet({ path: PATH_EMPLOYEE_PAYROLL_TYPES })
        .then(json => json.data)
        .then(employeePayrollTypes => {
          commit('updateStatus', { status: COMPLETE })
          commit('setEmployeePayrollTypes', employeePayrollTypes)
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
    }
  }
}

export default employeePayrollTypes
